<template>
    <div>
        <div style="text-align: center;width: 100%;position: fixed;bottom: 20px;font-size: 30px"><a href="https://beian.miit.gov.cn" target="_blank">蜀ICP备2020034715号</a></div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                currentDate: new Date()
            };
        }
    }
</script>
<style>
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }
    .time {
         font-size: 13px;
         color: #999;
     }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>


// WEBPACK FOOTER //
// src/views/user/welcome.vue